import React from "react";
import { AccessItem } from "./AccessItem";
import { PendingAccessControls } from "./PendingAccessControls";

interface PendingInviteRowProps {
  email: string;
  canRevokeAccess: boolean;
  onResend?: () => Promise<void>;
  onRevoke?: () => Promise<void>;
  isActive?: boolean;
  onMenuToggle?: (isOpen: boolean) => void;
}

export const PendingInviteRow: React.FC<PendingInviteRowProps> = ({
  email,
  canRevokeAccess,
  onResend,
  onRevoke,
  isActive,
  onMenuToggle,
}) => (
  <AccessItem
    primaryText={email}
    tooltipText={email}
    isPending
    isActive={isActive}
    permissionLabel={
      <PendingAccessControls
        email={email}
        canRevokeAccess={canRevokeAccess}
        onResend={onResend}
        onRevoke={onRevoke}
        onMenuToggle={onMenuToggle}
      />
    }
    canRevokeAccess={false}
    isCurrentUser={false}
  />
);
